'use client';
'use strict';

var classes = {"yearsList":"m-9206547b","yearsListCell":"m-c5a19c7d"};

module.exports = classes;
//# sourceMappingURL=YearsList.module.css.cjs.map
